import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})

export class FacilitiesComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] =
  [
    {
      title: 'Locuri individuale de parcare',
      content: `
        Nu îți vei mai pune niciodată problema dacă ai unde să parchezi sau nu.
        Conceptul Dream Residence pune la dispoziție atât parcări subterane, cât și supraterane,
        pentru tine și musafirii tăi.
      `,
      image: {
        url: '/assets/icons/facilities/parcare.svg'
      }
    },
    {
      title: 'Spații verzi',
      content: `
        Ne asigurăm de bunăstarea rezidenților noștri. Vei beneficia de spații comune verzi,
        unde te poți recrea. Natura te va bucura în fiecare anotimp, în timp ce tu ai la
        dispoziție beneficiile unui stil de viață modern, dar și liniștea și frumusețea naturii.
      `,
      image: {
        url: '/assets/icons/facilities/spatii-verzi.svg'
      }
    },
    {
      title: 'Dotări locuință',
      content: `
        Apartamentul tău se va preda complet finisat (gresie, faianța, parchet, uși interioare,
          obiecte sanitare în baie, centrală termică, radiatoare, prize, întrerupătoare și racordat
          la toate utilitățile (gaze naturale, energie electrică, apă curentă, canalizare)
      `,
      image: {
        url: '/assets/icons/facilities/dotari.svg'
      }
    },
    {
      title: 'Facilități la îndemână',
      content: `
        Ne-am gândit că o locuință ideală în visul fiecăruia ar pune la dispoziție
        toate cele necesare pentru un trai modern.  Ești aproape de marile centre comerciale din zonă
        (Mega Image, Liberty Mall, Kaufland, Cora, Carrefour Vulcan). Ajungi repede în centrul orașului
        (numai 4 km pana la Unirii). În proximitatea apartamentelor se află școli, grădinițe, dar și un
        parc în imediata vecinătate.
      `,
      image: {
        url: '/assets/icons/facilities/facilitati.svg'
      }
    },
    {
      title: 'Tu îți personalizezi locuința',
      content: `
        Casa este sanctuarul tău, iar noi știm asta. De aceea, te ajutăm
        să-ți personalizezi locuința prin alegerea finisajelor pe care ți le
        punem la dispoziție. Nu îți face griji, avem o paletă largă. Suntem
        siguri că vei găsi ceva pe gustul tău.
        Noi dăm viață visului tău, rămâne la latitudinea ta modul în care
        scrii povestea casei tale.
      `,
      image: {
        url: '/assets/icons/facilities/personalizare.svg'
      }
    },
    {
      title: 'Siguranța ta, prioritatea noastră',
      content: `
        Nimic nu este mai presus pentru noi decât confortul și siguranța ta și a familiei tale. De aceea,
        ne-am luat angajamentul să dotăm fiecare bloc pe care îl adăugăm proiectului nostru cu sisteme
        de supraveghere video, atât în spațiile comune cât și în afară . Ba mai mult, fiecare apartament va
        beneficia de videointerfon. Toate acestea fac parte din conceptul Dream, o comunitate sigură,
        caldă, fericită, un loc ideal pentru tine și pentru familia ta. Bun venit acasă, în Cartierul Nou Rahova !
      `,
      image: {
        url: '/assets/icons/facilities/siguranta.svg'
      }
    }
  ];

  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'robots', content: 'noindex' }
    ]);
    this.setTitle('Facilitățile proiectului Dream Residence');
  }
}



// WEBPACK FOOTER //
// ./src/app/about-us/facilities.component.ts